module.exports = __webpack_public_path__ + "img/steam2.67fea2cd.svg";